import React, { useEffect, useState } from 'react';
import grey from 'sushiweb/tokens/color/grey';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import Button from 'sushiweb/Button';
import Spinner from 'sushiweb/Spinner/Spinner';
import red from 'sushiweb/tokens/color/red';
import Layout from 'sushiweb/Layout/Layout';
// import HorizontalTabs from 'sushiweb/HorizontalTabs';
import {
  DashboardWrapper,
  HeaderH4,
  HeadWrapper,
  LayoutContainers,
  SpinnerHolder,
  TableContainer,
  StyledH6,
  Header,
  StyledDiv,
  CalendarIcon,
  // TabsContainer,
} from '../common/styles';
import DataTables from '../common/components/DataTables';
// import Error from '../common/components/DataTables/components/Error';
import { StatusContainer } from '../common/components/DataTables/styles';
import DetailsWrapper from '../common/components/DetailsWrapper/DetailsWrapper';
import { StyledLayout } from '../WalletPrograms/styles';
import {
  // groupDetailsHeadColumn,
  // eventDetailsHeadColumn,
  giftCardProgramHeadColumn,
} from '../common/components/DataTables/components/headColumns';
import {
  ACTIVE,
  CONFIRM_PROGRAM_DEACTIVATION,
  REFRESH_LABEL,
  SCHEDULED,
} from '../common/components/constants';
import ConfirmDeactivate from '../common/components/ConfirmDeactivate/ConfirmDeactivate';
import ErrorPage from '../common/components/ErrorPage';
import { displayDateFormat } from '../../helpers';

const ProgramInfo = ({
  fetchingProgramInfo,
  fetchedProgramInfo,
  programInfo,
  getProgramInfo,
  fetchingProgramStatus,
  getProgramStatus,
}) => {
  const {
    total = 0,
    status = 0,
    program_name: name = '',
    program_type: programType = '',
    giftcard_count: giftaCardCount = '',
    // total_employees: totalEmployees = '',
    display_amount: amountPerGiftCard = '',
    program_freq: programFrequency = '-',
    // expiry_duration: expiry = '-',
    ends_on: endsOn = '',
    starts_on: startsOn = '',
    groups = [],
  } = programInfo;
  // const emptyGroups = !fetchingProgramInfo && total === 0;
  const { id = '' } = useParams();
  // const groupsFetchError = !fetchingProgramInfo && !fetchedProgramInfo;
  const [loading, setLoading] = useState(true);
  const [currentData, setCurrentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [deactivateConfirm, setDeactivateConfirm] = useState(false);
  // const [activeIndex, setActiveIndex] = useState(true);
  // const [headColumns, setHeadColumns] = useState(eventDetailsHeadColumn);
  const warning = true;
  const width = programType === 'EVENT' ? 4 : 3;

  useEffect(() => {
    getProgramInfo(id);
  }, []);

  useEffect(() => {
    if (!fetchingProgramInfo) {
      groups.sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
      setCurrentData(groups.slice(0, 10));
      setLoading(false);
    }
  }, [fetchingProgramInfo]);

  useEffect(() => {
    if (groups.length > 0) {
      const start = currentPage * 10 - 10;
      const end = currentPage * 10;
      const rangeData = groups.slice(start, end);
      setCurrentData(rangeData);
    }
  }, [currentPage]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  // const onRefresh = () => {
  //   handlePageChange(1);
  // };

  const openDeactivateConfirm = () => {
    setDeactivateConfirm(true);
  };

  const closeDeactivateConfirm = () => {
    setDeactivateConfirm(false);
  };

  const refreshPage = () => {
    getProgramInfo(id);
  };

  const activateProgram = () => {
    getProgramStatus({
      id,
      activate: false,
    });
    closeDeactivateConfirm();
  };

  // const handleActiveIndex = () => {
  //   const currentHeadCol = activeIndex
  //     ? groupDetailsHeadColumn
  //     : eventDetailsHeadColumn;
  //   setActiveIndex(!activeIndex);
  //   setHeadColumns(currentHeadCol);
  // };

  const ActionComponent = () => {
    if ([ACTIVE, SCHEDULED].includes(status)) {
      return (
        <Button onClick={openDeactivateConfirm} loading={fetchingProgramStatus}>
          Deactivate Program
        </Button>
      );
    }
    return null;
  };

  // if (!fetchedProgramInfo) {
  //   return (
  //     <DashboardWrapper>
  //       <ErrorPage
  //         showAction
  //         actionLabel={REFRESH_LABEL}
  //         clickAction={refreshPage}
  //       />
  //     </DashboardWrapper>
  //   );
  // }

  return fetchingProgramInfo ? (
    <DashboardWrapper>
      <SpinnerHolder className='center'>
        <Spinner color={red.z_red} size='medium' />
      </SpinnerHolder>
    </DashboardWrapper>
  ) : (
    <DashboardWrapper>
      <HeadWrapper>
        <HeadWrapper.Left>
          <div>
            <Header>
              <HeaderH4>{name}</HeaderH4>
              <StatusContainer status={status}>{status}</StatusContainer>
            </Header>
            <StyledDiv>
              <StyledH6>
                <CalendarIcon color={grey.z600} size={12} />
                {programFrequency}
              </StyledH6>
            </StyledDiv>
          </div>
        </HeadWrapper.Left>
        <ActionComponent />
      </HeadWrapper>
      <LayoutContainers>
        <StyledLayout gap={20}>
          <Layout.Item colD={width} colT={width} colM={6}>
            <DetailsWrapper label='Program Type' value={programType} />
          </Layout.Item>
          <Layout.Item colD={width} colT={width} colM={6}>
            <DetailsWrapper label='No. of gift card' value={giftaCardCount} />
          </Layout.Item>
          {programType !== 'EVENT' && (
            <Layout.Item colD={width} colT={width} colM={6}>
              <DetailsWrapper
                label='Duration'
                value={`${displayDateFormat(startsOn)} to ${displayDateFormat(
                  endsOn,
                )}`}
              />
            </Layout.Item>
          )}
          <Layout.Item colD={width} colT={width} colM={6}>
            <DetailsWrapper
              label='Amount Per Gift Card'
              value={amountPerGiftCard}
            />
          </Layout.Item>
        </StyledLayout>
      </LayoutContainers>
      {/* <TabsContainer>
        <HorizontalTabs alignLinks='left'>
          <HorizontalTabs.Link
            active={activeIndex === true}
            onClick={handleActiveIndex}
          >
            Event Details
          </HorizontalTabs.Link>
          <HorizontalTabs.Link
            active={activeIndex === false}
            onClick={handleActiveIndex}
          >
            Group Details
          </HorizontalTabs.Link>
        </HorizontalTabs>
      </TabsContainer> */}
      <TableContainer>
        {!fetchedProgramInfo ? (
          <ErrorPage
            showAction
            actionLabel={REFRESH_LABEL}
            clickAction={refreshPage}
          />
        ) : (
          <DataTables
            columns={giftCardProgramHeadColumn}
            loading={fetchingProgramInfo || loading}
            data={currentData}
            pagination
            totalRows={total}
            handlePageChange={handlePageChange}
          />
        )}
      </TableContainer>
      <ConfirmDeactivate
        title={CONFIRM_PROGRAM_DEACTIVATION.title}
        message={CONFIRM_PROGRAM_DEACTIVATION.message}
        isVisible={deactivateConfirm}
        closeModal={closeDeactivateConfirm}
        buttonLabel='Continue'
        onContinueClick={activateProgram}
        warning={warning}
      />
    </DashboardWrapper>
  );
};

ProgramInfo.propTypes = {
  programInfo: PropTypes.objectOf(PropTypes.any),
  getProgramInfo: PropTypes.func,
  getProgramStatus: PropTypes.func,
  fetchingProgramStatus: PropTypes.bool,
  fetchingProgramInfo: PropTypes.bool,
  fetchedProgramInfo: PropTypes.bool,
};

ProgramInfo.defaultProps = {
  programInfo: {},
  getProgramInfo: _noop,
  getProgramStatus: _noop,
  fetchingProgramStatus: false,
  fetchedProgramInfo: true,
  fetchingProgramInfo: true,
};

export default ProgramInfo;
